import { useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Divider } from "primereact/divider";
import { Avatar } from "primereact/avatar";
import { InputText } from "primereact/inputtext";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function HeaderBar({ onSidebarToggle }) {
  const { user, setToken, setUser } = useAuth();
  const navigate = useNavigate();
  const menuRef = useRef(null); 
  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    navigate("/login");
  };

  const menuItems = [
    {
      label: "Profilim",
      icon: "pi pi-user",
      command: () => navigate("/profile"),
    },
    {
      label: "Çıkış Yap",
      icon: "pi pi-sign-out",
      command: logout,
    },
  ];

  return (
    <header className="h-[56px] flex items-center justify-between px-4 bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm z-[1060] sticky top-0 transition-all">
      {/* SOL: Menüyü aç/kapat & Arama */}
      <div className="flex items-center gap-3 flex-1">
        <Button
          icon="pi pi-bars"
          className="p-button-text !text-gray-600 hover:!bg-gray-100 !rounded-lg !w-10 !h-10 p-0"
          onClick={onSidebarToggle}
          aria-label="Menüyü Gizle/Göster"
        />

        <div className="hidden md:flex relative w-64 lg:w-80 group">
          <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
          <InputText
            placeholder="Sistemde ara..."
            className="w-full !pl-9 !bg-gray-50 !border-none !rounded-xl !text-[13px] !py-2 group-focus-within:!ring-1 group-focus-within:!ring-blue-100 transition-all"
          />
        </div>
      </div>

      {/* SAĞ: Bildirimler + Kullanıcı + Tenant */}
      <div className="flex items-center gap-2 md:gap-4">
        <div className="flex items-center gap-0.5">
          <Button
            icon="pi pi-bell"
            className="p-button-rounded p-button-text !text-gray-500 hover:!bg-gray-50 !w-9 !h-9"
            tooltip="Bildirimler"
            tooltipOptions={{ position: 'bottom' }}
          />
          <Button
            icon="pi pi-cog"
            className="p-button-rounded p-button-text !text-gray-500 hover:!bg-gray-50 !w-9 !h-9"
            tooltip="Hızlı Ayarlar"
            tooltipOptions={{ position: 'bottom' }}
          />
        </div>

        <Divider layout="vertical" className="!hidden md:!block !mx-0 !h-8 !border-gray-200" />

        <div
          className="flex items-center gap-3 cursor-pointer hover:bg-gray-50 p-1.5 rounded-xl transition-all group"
          onClick={(e) => menuRef.current.toggle(e)}
        >
          <div className="hidden md:flex flex-col text-right leading-tight">
            <div className="font-bold text-sm text-gray-800 group-hover:text-blue-600 transition-colors">
              {user?.FullName || "Kullanıcı"}
            </div>
            <div className="text-[11px] font-bold text-gray-400 uppercase tracking-wider">
              {user?.TenantName || "Şirket Adı"}
            </div>
          </div>

          <Menu model={menuItems} popup ref={menuRef} />

          <Avatar
            label={user?.FullName?.charAt(0) || "K"}
            className="!bg-blue-600 !text-white !font-bold !rounded-xl shadow-md group-hover:scale-105 transition-transform"
            shape="square"
            size="normal"
          />
        </div>
      </div>
    </header>
  );
}
